import { Component, Input, OnInit } from '@angular/core';

import { IColunaValor } from '../../interface/icm-valor-generico';

@Component({
    selector: 'icm-coluna-valor',
    templateUrl: './view/icm-coluna-valor.component.html',
    styleUrls: ['./view/icm-coluna-valor.component.scss'],
})
export class IcmColunaValorComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaValor;
    @Input() carregando: boolean;

    valor: number | string | Date;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.valor = this.coluna.valor(this.linha);
        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
    }
}
